// extracted by mini-css-extract-plugin
module.exports = {"wrong-outer":"ErrorBoundary_wrong-outer__KBeRy","wrong-inner":"ErrorBoundary_wrong-inner__cPKNB","img-went-wrong":"ErrorBoundary_img-went-wrong__3cbv-"};